import {
  type ApprovalSchemeApi,
  type ApprovalScheme,
} from '../../company/structure/approval-flows';
import {
  normalizeRules,
  removeAoRule,
  shouldRemoveAoRule,
} from '../../company/structure/approval-flows/models';

export const reshapeApprovalScheme = (
  scheme: ApprovalSchemeApi,
): ApprovalScheme => {
  const { rules } = shouldRemoveAoRule(scheme) ? removeAoRule(scheme) : scheme;
  return { ...scheme, rules: normalizeRules(rules) };
};
